"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPluginArguments = exports.AddPluginOptions = void 0;
exports.AddPluginOptions = [
    {
        name: "api-plugin-type",
        type: "string",
        description: "Action type.",
        required: true,
        default: "new-api",
        choices: ["api-spec", "mcp"],
    },
    {
        name: "openapi-spec-type",
        type: "string",
        description: "The type of the API spec.",
        choices: ["enter-url", "open-file", "search-api"],
    },
    {
        name: "openapi-spec-location",
        type: "string",
        shortName: "a",
        description: "OpenAPI description document URL.",
    },
    {
        name: "api-operation",
        type: "array",
        shortName: "o",
        description: "Select operation(s) Copilot can interact with.",
    },
    {
        name: "search-openapi-spec-query",
        type: "string",
        description: "Search OpenAPI Document",
    },
    {
        name: "select-openapi-spec",
        type: "string",
        description: "Select OpenAPI Document",
    },
    {
        name: "mcp-da-server-url",
        type: "string",
        description: "MCP Server URL",
    },
    {
        name: "mcp-tools-file-path",
        type: "string",
        description: "MCP Tools Definition File",
    },
    {
        name: "mcp-da-auth-type",
        type: "string",
        description: "Select Authentication Type",
        default: "oauth",
        choices: ["oauth", "entraSSO"],
    },
    {
        name: "manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the app manifest file path.",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.AddPluginArguments = [];
//# sourceMappingURL=AddPluginOptions.js.map